var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDAF14",
    d: "M39.75,35.048c0,2.597-2.105,4.702-4.702,4.702H4.952c-2.597,0-4.702-2.105-4.702-4.702V4.952 c0-2.597,2.105-4.702,4.702-4.702h30.096c2.597,0,4.702,2.105,4.702,4.702V35.048z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.728,29.669c0.12-0.449,0.246-0.896,0.359-1.347c0.299-1.186,0.588-2.372,0.89-3.555 c0.03-0.117,0.097-0.24,0.182-0.325c3.718-3.725,7.439-7.446,11.161-11.167c0.028-0.028,0.059-0.053,0.073-0.066 c1.465,1.464,2.925,2.924,4.396,4.396c-0.026,0.029-0.074,0.083-0.124,0.133c-3.685,3.683-7.368,7.367-11.056,11.045 c-0.112,0.11-0.269,0.205-0.422,0.243c-1.591,0.407-3.185,0.803-4.779,1.199c-0.361,0.091-0.487,0.037-0.681-0.275 C9.728,29.855,9.728,29.762,9.728,29.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.271,13.498c-0.028,0.109-0.041,0.225-0.089,0.323c-0.136,0.274-0.234,0.585-0.436,0.801 c-0.536,0.576-1.12,1.109-1.671,1.647c-1.442-1.442-2.906-2.905-4.349-4.347c0.538-0.551,1.06-1.148,1.646-1.673 c0.777-0.696,2.078-0.678,2.857,0.021c0.532,0.477,1.023,0.999,1.519,1.515c0.306,0.318,0.428,0.73,0.522,1.151 C30.271,13.123,30.271,13.311,30.271,13.498z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.61907902b627e11f6c22d53ad52d4e0f.svg";
export { ForwardRef as ReactComponent };